<template id="home-version-1" class="home-version-3" data-style="default">
  <div id="app" :class="activeTheme.className">
    <div class="tpl-snow" v-if="activeTheme.effects.snow">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { themeState } from "@/themes";

export default {
  name: "App",
  components: {},
  data() {
    return {
      themeState
    };
  },
  computed: {
    activeTheme() {
      return this.themeState.activeTheme;
    }
  },
  mounted() {
    this.$setTheme("base");
    this.$initLanguaje();
  }
};
</script>

<style>
</style>
